import announcementApi from './announcementApi';

const deleteAnnouncement = async (id: number) => {
  try {
    const { data } = await announcementApi({
      method: 'DELETE',
      url: `/${id}`,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    });
    return data;
  } catch (error) {
    console.error('[deleteAnnouncement] Failed:', error);
    throw error;
  }
};

export default deleteAnnouncement;
